// extracted by mini-css-extract-plugin
export default {"button":"CollapsibleButton-module__button--fu+Pf","buttonText":"CollapsibleButton-module__buttonText--hq-k4"};